<div mat-dialog-title class="dialog-title p-3 pr-5 clearfix">
  <h5>
    Select Work Permits
    <span *ngIf="dataSource.selection.selected.length">
      ({{ dataSource.selection.selected.length }})
    </span>
  </h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>

  <button
    mat-raised-button
    color="primary"
    type="button"
    class="m-1 mr-2"
    (click)="onAddWorkPermit()"
    *ngIf="app.isAuthenticated && app.user.is_sitesoft_admin">
    <mat-icon>add</mat-icon> New Work Permit
  </button>

  <form class="form-inline my-2 my-xl-0 float-xl-right" (ngSubmit)="dataSource.getData(true)">
    <button
      mat-raised-button
      type="button"
      class="mr-2 mr-xl-3 my-1"
      (click)="onOpenFilters()"
      matTooltip="Click this button to display filter options for this list.">
      <mat-icon>filter_list</mat-icon> Filter
    </button>

    <input
      class="form-control mr-2 my-1"
      type="search"
      [(ngModel)]="dataSource.search"
      name="search"
      placeholder="Search"
      aria-label="Search"/>

    <button
      mat-raised-button
      color="secondary"
      class="mr-2 mr-xl-3 my-1"
      type="submit"
      matTooltip="Run the current search">
      <mat-icon>search</mat-icon> Search
    </button>

    <button mat-raised-button class="mr-2 my-1" (click)="onClearSelected()" type="button">
      Clear Selected
    </button>
  </form>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    matSortActive="title"
    matSortDirection="asc"
    matSortDisableClear >
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
        <mat-checkbox
          (change)="$event ? dataSource.selectAllToggle() : null"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? dataSource.selection.toggle(row.id) : null"
          [checked]="dataSource.selection.isSelected(row.id)"
          appMarginRight>
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
      <td mat-cell *matCellDef="let element" class="text-wrap">
        {{ element.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
      <td mat-cell *matCellDef="let element" class="text-wrap">
        {{ element.title | ellipsis: ['30'] }}
      </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
      <td mat-cell *matCellDef="let element" class="text-wrap">
        {{ element.description | ellipsis: ['60'] }}
      </td>
    </ng-container>

    <ng-container matColumnDef="industry">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Industry</th>
      <td mat-cell *matCellDef="let element" class="text-wrap">
        {{ element.industry ? element.industry.name : "" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Created</th>
      <td mat-cell *matCellDef="let element" class="text-wrap">
        {{ (element.date_created * 1000) | timezoneConvertMedium }}
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created_UTC">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Created (UTC)</th>
      <td mat-cell *matCellDef="let element" class="text-wrap">
        {{ (element.date_created * 1000) | timezoneConvertUTCMedium }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="dataSource.selection.toggle(row.id)"></tr>
  </table>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-end px-3 py-1">
  <mat-paginator
    class="my-2 ml-1 mr-2"
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>

  <button
    class="my-2 mx-1"
    mat-raised-button
    color="primary"
    type="button"
    (click)="onSaveAndClose()"
    [disabled]="!data['multiple'] && !dataSource.selection.hasValue()">
    Select & Close
  </button>
</mat-dialog-actions>


